module.exports = __webpack_public_path__ + "media/react/assets/TeamReview-c6f97230fd229e7701d5a18172951f5e.svg";